module.exports = __webpack_public_path__ + "assets/img/29_193_big.2b25df4a.jpg";